import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CurrentUser } from '@otas/model/current-user';

@Injectable({
    providedIn: 'root'
})
export class WithoutInterceptor {
    private http: HttpClient;
    constructor(httpBackend: HttpBackend) {
        this.http = new HttpClient(httpBackend)
    }
    get<T>(url, options?): Observable<any> {
        const user = sessionStorage.getItem('CURRENT_USER');
        const crntUser: CurrentUser = !!user ? JSON.parse(user) : null;
        const tokeN = !!crntUser ? crntUser.accessToken : null;
        if (!!tokeN) {
            const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokeN);
            options = Object.assign({}, options, {headers})

        }
        return this.http.get<T>(url, options);
    }
    post<T>(url, body, options?): Observable<any> {
        const user = sessionStorage.getItem('CURRENT_USER');
        const crntUser: CurrentUser = !!user ? JSON.parse(user) : null;
        const tokeN = !!crntUser ? crntUser.accessToken : null;
        if (!!tokeN) {
            const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokeN);
            options = Object.assign({}, options, {headers})
        }
        return this.http.post<T>(url, body, options);
    }
}
